import { Icon, MenuItem, MenuList, Popover } from '@material-ui/core';
import React from 'react';

const CustomPopover = ({ anchorEl, open, onClose, content }) => {
    return (
        <Popover
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <MenuList>
                {content.map((item, index) => (
                    <MenuItem key={index} onClick={item.onClick}>
                        <Icon >{item.Icon}</Icon>
                        <div className='me-3' />
                        {item.text}
                    </MenuItem>
                ))}
            </MenuList>
        </Popover>
    );
};

export default CustomPopover;